function createElement(tag, attributes = {}, ...children) {
	if (tag.includes('.')) {
		const split = tag.trim().split('.')
		tag = split.shift()
		attributes.class = split.join(' ')
	}

	if (tag.includes('#')) {
		const split = tag.trim().split('#')
		tag = split.shift()
		attributes.id = split.join('')
	}

	const el = document.createElement(tag)

	// Apply attributes etc.
	for (const [key, value] of Object.entries(attributes)) {
		if (key === 'style') {
			for (const [property, val] of Object.entries(value)) {
				el.style[property] = val
			}
		}
		else if (key === 'class' || key === 'classname' || key === 'className') {
			el.className = value
		}
		else if (/^on[A-Z]/.test(key)) {
			el.addEventListener(key.substr(2).toLowerCase(), value)
		}
		else {
			el[key] = value
		}
	}

	// Append any child (recursively).
	function addChildNode(node, level = 0) {
		if (node === false || node === undefined || node === null) {
			return
		}
		if (Array.isArray(node)) {
			node.forEach(child => addChildNode(child, level + 1))
		}
		else if (node instanceof HTMLElement) {
			el.appendChild(node)
		}
		else if (/<\s*[^>]+>/.test(node)) {
			el.innerHTML += node
		}
		else {
			const text = document.createTextNode(node)
			el.appendChild(text)
		}
	}

	for (const child of children) {
		addChildNode(child)
	}

	return el
}

document.addEventListener('DOMContentLoaded', () => {
	const preferences = GUPStorage.get()
	
	if (preferences === null) {
		const saveString = 'Opslaan'
		const options = { allow: 'Alle toestaan', tracking: 'Tracking cookies', analytical: 'Analytische cookies', functional: 'Functionele cookies' }

		let selectionState = Object.keys(options).filter(o => o != 'allow')

		// Overview container.
		const acceptAllButton = createElement(
			'div.gup-button.accept-all', 
			{ 
				role: 'button',
				onClick: (event) => {
					const { innerHTML } = event.currentTarget
					if (innerHTML == options.allow) { 
						GUPStorage.set(['allow'])
					} else if (innerHTML == saveString) {
						GUPStorage.set(selectionState)
					}
					location.reload()
				} 
			}, 
			options.allow
		)
		
		const overview = createElement('div.overview-container', {}, [
			createElement('div.column.content', {}, [
				createElement('p.title', {}, 'Cookies'), 
				createElement('p.description', {}, 'Greenboutiq gebruikt cookies om u de beste online ervaring te bieden.' )
			]),
			createElement('div.column.options', {}, acceptAllButton)
		])

		// Detailed container.
		function createCheckbox(name, label, onChange, title, disabled) {
			const id = label.toLowerCase()
			return createElement(`div.gup-checkbox${disabled ? '.disabled' : ''}`, { title }, [
				createElement('input', { id: id, type: 'checkbox', name, disabled, onChange: !disabled ? onChange : undefined, checked: true }),
				createElement('label', { for: id }, label)
			])
		}

		const onOptionChange = (event) => {
			const { name, checked } = event.currentTarget
			if (!checked && selectionState.includes(name)) {
				selectionState = selectionState.filter(o => o !== name)
			} else if (checked && !selectionState.includes(name)) {
				selectionState.push(name)
			}
		}

		const checkboxes = Object.entries(options).map(([key, value]) => {
			if (key !== 'allow') {
				const disabled = key == 'functional'
				const title = disabled ? 'Functionele cookies zijn cookies die nodig zijn voor de werking van de website. Deze kunnen niet uitgezet worden.' : null
				return createCheckbox(key, value, onOptionChange, title, disabled)
			} else return null
		}).filter(Boolean).reverse()

		const checkboxContainer = createElement('div.checkbox-container', {}, checkboxes)
		const detailedContainer = createElement('div.detailed-container.closed', {}, checkboxContainer)

		// Show-more container.
		const onAdvancedClick = (event) => {
			const isOpen = event.currentTarget.classList.contains('open')
			acceptAllButton.innerHTML = !isOpen ? saveString : options.allow
			event.currentTarget.classList[(!isOpen ? 'add' : 'remove')]('open')
			detailedContainer.classList[(isOpen ? 'add' : 'remove')]('closed')
		}

		const advancedButton = createElement('div.gup-button.advanced', { role: 'button', onClick: onAdvancedClick }, ['Geavanceerd', `
			<svg class="icon--apollo-down-carrot header__nav__link--icon vib-center" height="6px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 13.3" xml:space="preserve">
				<g class="hover-fill" fill="var(--nav-color)">
    				<polygon points="17.7,0 10,8.3 2.3,0 0,2.5 10,13.3 20,2.5 "></polygon>
    			</g>
    			<style>.header__nav__link .icon--apollo-down-carrot:hover .hover-fill { fill: var(--nav-color);}</style>
    		</svg>
		`.trim()])
		const showMore = createElement('div.show-more', {}, advancedButton)

		const cookiebar = createElement('div#gbq-user-preferences', {}, [overview, showMore, detailedContainer])
		document.body.appendChild(cookiebar)
	}
})